import { ajax } from '../index'

/**
 * 搜索二级页 相关接口
 */
export default {
  // 获取search 商品数据
  getSearchResult(dataObj: any) {
    return ajax.get('api', `/api/v1/search/keyword`, dataObj)
  },

  // 获取hot products数据
  getHotProducts(categoryId: string | number) {
    return ajax.get('api', `/api/v1/category/hot-products/${categoryId}`, {})
  },

  // 获取shop 商品数据
  getShopResult(dataObj: any) {
    return ajax.get('api', `/api/v1/search/shop`, dataObj)
  }
}